import { User } from '@nextui-org/react';
import classNames from 'classnames';
import { FC, useMemo, useState } from 'react';

import style from './avatar.style.module.scss';

type Props = {
  name: string;
  imageUrl?: string;
  onClick?: (event: any) => void;
  size: string;
  isChannelLive?: string;
};

const Avatar: FC<Props> = ({
  name,
  imageUrl,
  onClick,
  size,
  isChannelLive,
}) => {
  const [error, setError] = useState<boolean>(false);
  const getName = useMemo(() => {
    const tokens = name?.toUpperCase().split(' ') || ['', ''];

    if (tokens.length >= 2) {
      return `${tokens[0].charAt(0)}${tokens[1].charAt(0)}`;
    }

    return (name || '').charAt(0).toUpperCase();
  }, [name, imageUrl]);

  return (
    <User
      name={''}
      onClick={(event) => {
        onClick && onClick(event);
      }}
      onError={() => {
        setError(true);
      }}
      className={classNames(style.avatar, {
        [style['avatar--live']]: isChannelLive === 'true',
      })}
      size={size}
      text={getName}
      src={!error ? imageUrl : ''}
      zoomed
      pointer
    />
  );
};

export default Avatar;
